import { useContext, useMemo, useState } from 'react';
import { StaticContext } from '@sm/webassets';

import { PackageIds } from '~shared/constants/pricing';
import { STARTER_ENABLED_COUNTRIES } from '~pricing/lib/constants';

import { StarterEnabled } from './types';

/**
 * Given an authenticated user and the country they live in, check to see if
 * that country is in the list of countries that qualify for Standard Annual.
 * @returns {StarterEnabled} A boolean flag: { isStarterEnabled: boolean; }
 */
export default function useStarterEnabled(): StarterEnabled {
  const [isStarterEnabled, setIsStarterEnabled] = useState(false);
  const {
    user: {
      package: packageID,
      isAuthenticated,
      subscribedAt,
      billingCountry, //  see https://momentiveai.atlassian.net/browse/GROW-2417
    },
    environment: { countryCode }, // use countryCode otherwise use billingCountry
  } = useContext(StaticContext);

  useMemo(() => {
    const convertedPackageID = parseInt(packageID, 10);
    const isQualifiedBasedOnAuthAndCountry =
      isAuthenticated && STARTER_ENABLED_COUNTRIES.includes(countryCode ?? billingCountry);
    // if the user package_id is 32 then there is no need to check subscription status
    if (isQualifiedBasedOnAuthAndCountry && convertedPackageID === PackageIds.STANDARD_ANNUAL) {
      setIsStarterEnabled(true);
    } else {
      setIsStarterEnabled(isQualifiedBasedOnAuthAndCountry && convertedPackageID === PackageIds.BASIC && !subscribedAt);
    }
  }, [packageID, billingCountry, countryCode, isAuthenticated, subscribedAt]);
  return {
    isStarterEnabled,
  };
}
